import { motion } from 'framer-motion';
import './BreathingBlocks.css';

/**
 * BreathingBlocks
 * A stack of folded, glossy ribbon planks that slowly scale and drift,
 * like they're breathing - the diagonal 3D-plank motif from the reference,
 * rebuilt with our own palette and proportions rather than copied assets.
 * Pure CSS gradients + framer-motion, no images.
 */
const PLANKS = [
  { cls: 'plank plank--a', duration: 5.5, delay: 0 },
  { cls: 'plank plank--b', duration: 6.5, delay: 0.4 },
  { cls: 'plank plank--c', duration: 5, delay: 0.9 },
  { cls: 'plank plank--d', duration: 7, delay: 0.2 },
];

export default function BreathingBlocks({ className = '' }) {
  return (
    <div className={`breathing-blocks ${className}`} aria-hidden="true">
      {PLANKS.map((plank) => (
        <motion.div
          key={plank.cls}
          className={plank.cls}
          animate={{ scaleY: [1, 1.055, 1], y: [0, -10, 0] }}
          transition={{
            duration: plank.duration,
            delay: plank.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
}
